const ReadingProgress = {};

{

    const _readingProgress = () => {
        const getMax = () => {
            return $(document).height() - $(window).height();
        }

        const getValue = () => {
            return $(window).scrollTop();
        }

        const progressBarEl = $('#progressBar');

        if (!progressBarEl || !progressBarEl.length) return;

        // Set the Max attr for the first time
        progressBarEl.attr({ max: getMax() });

        const _changeValue = () => {
            progressBarEl.attr({ value: getValue() });
        }

        const _changeValueThrottle = throttle(() => requestAnimationFrame(_changeValue), 50);

        const _handlerResize = () => {
            progressBarEl.attr({ max: getMax(), value: getValue() });
        }

        const _handlerResizeThrottle = throttle(() => requestAnimationFrame(_handlerResize), 300);

        $(document).on('scroll', _changeValueThrottle);

        $(window).resize(_handlerResizeThrottle);
    }

    ReadingProgress.init = () => {
        _readingProgress();
    }
}